
















import { propOfType } from '@/services/utils';
import Vue from 'vue';
import msg from '@/services/userMsg';
import { Group } from '@/models/requests-and-responses/grupos';
import { ErrorCode, errorCodeFromAxiosError } from '@/models/ErrorCode';
import { post } from '@/services/http';
import GroupForm from './GroupForm.vue';

// --- RequestStatus

// Estado de la llamada a la API

type RequestStatus =
  | { status: 'notAsked' }
  | { status: 'loading' }
  | { status: 'error', error: ErrorCode }

function notAsked(): RequestStatus {
  return { status: 'notAsked' };
}

// --- Model
function newGroup(idCliente: number): Group {
  return {
    id: 0,
    nombre: '',
    descripcion: '',
    idCliente,
  };
}
// --- Componente

export default Vue.extend({
  props: {
    idCliente: propOfType<number>(),
    onClose: propOfType<Function>(() => () => {}),
    onSave: propOfType<Function>(() => () => {}),
  },
  components: { GroupForm },
  data() {
    return {
      model: newGroup(this.idCliente),
      save: notAsked(),
      showErrors: false,
      errorFound: false,
    };
  },
  methods: {
    onSaveButtonClick(): void {
      this.showErrors = true;
      if (this.errorFound) {
        return;
      }

      if (this.save.status === 'loading') {
        return;
      }

      this.save = { status: 'loading' };

      post('$sgv/rest/cuentas/grupos', { ...this.model })
        .then(() => {
          this.showErrors = false;
          this.$toast.success(msg.getSuccess('group_created'));
          this.onSave();
        })
        .catch((axiosError) => {
          const error = errorCodeFromAxiosError(axiosError);
          this.$toast.error(msg.getError(error));
          if (error) {
            this.save = { status: 'error', error };
          }
        });
    },
  },
});

